import React from 'react'

import Select from '../../UI/Select/Select'


const Actionresults = props => {
    const { onChange, show } = props
    if (show)
        return (
            <div className="columns is-vertical-center">
                <div className="colum is-4">
                    <h2 className='is-size-4'>Resultados</h2>
                </div>
                <div className="column is-2 is-offset-6">
                    <label htmlFor="">MOSTRAR</label>
                    <div className="select is-acervo-dark-green is-fullwidth">
                        <Select
                            placeholder='Seleccionar'
                            defaultValue={10}
                            name='itemsCountPerPage'
                            items={{ '10': 10, '25': 25, '50': 50, '100': 100 }}
                            onChange={e => onChange(e.target)}
                        />
                    </div>
                </div>
                <div className="column is-2">
                    <label htmlFor="">ACCIONES</label>
                    <div className="select is-acervo-dark-green is-fullwidth">
                        <Select
                            placeholder='Seleccionar'
                            name='actionDownload'
                            items={{ 'basic': 'Generar reporte', 'detail': 'Generar reporte detallado' }}
                            onChange={e => onChange(e.target)}
                        />
                    </div>
                </div>
            </div>
        )
    else 
    return <div></div>
}

export default Actionresults


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Home/ActionResults.js